const cookieLib = require('cookie')
const conf = require('./conf')

module.exports = {
  set (key, val, maxAge) {
    document.cookie = cookieLib.serialize(key, val, {
      maxAge,
      path: '/',
      domain: conf.cookieDomain,
    })
  },

  get (key) {
    return cookieLib.parse(document.cookie)[key]
  },
}
